<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="application.id">{{$t('modals.edit_application.title')}}</h1>
            <h1 v-else>{{$t('modals.create_application.title')}}</h1>
        </div>

        <application-form
            :application = "application"
            :wrapperClass="['modal__content']"
            @saved="onApplicationSaved">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </application-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, mixins } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';
    import ApplicationForm from '@/components/forms/dashboard/ApplicationForm';
    import { GET_APPLICATIONS } from '@/store/modules/applications';


    @Component({
        components: {
            ApplicationForm,
        }
    })
    export default class ApplicationModal extends Vue {
        name = 'application-modal';

        application = {};

        beforeOpen(event) {
            if (event.params && event.params.application) {
                this.application = event.params.application;
            }
        }

        onApplicationSaved(application) {
            this.$notify.success(this.$t('notify.application.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            this.$store.dispatch(GET_APPLICATIONS, {});
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/ApplicationModal.vue